import { Helmet } from 'react-helmet-async';

const SITE_NAME = 'CEFAT Business School';
const SITE_URL = 'https://cefat-bs.ci';
const DEFAULT_IMAGE = 'https://customer-assets.emergentagent.com/job_6e44ed24-b725-410d-8d63-89f25832c44c/artifacts/nejwwhlw_Capture%20d%27%C3%A9cran%202026-02-11%20211549.png';

const SEO_DEFAULTS = {
  title: 'CEFAT Business School | Ecole de Commerce Abidjan, Cote d\'Ivoire',
  description: 'CEFAT Business School Abidjan : Bachelor, MBA, formations diplomantes, qualifiantes et certifiantes. 4 centres d\'excellence en Cote d\'Ivoire. Inscrivez-vous maintenant.',
  keywords: 'ecole de commerce Abidjan, business school Cote d\'Ivoire, MBA Abidjan, Bachelor Abidjan, formation professionnelle Abidjan, CEFAT, diplomante, qualifiante, certifiante, linguistique, formation continue Abidjan',
};

export default function SEO({ 
  title, 
  description, 
  keywords,
  image,
  url,
  type = 'website',
  noindex = false 
}) {
  const pageTitle = title ? title + ' | ' + SITE_NAME : SEO_DEFAULTS.title;
  const pageDesc = description || SEO_DEFAULTS.description;
  const pageKeywords = keywords || SEO_DEFAULTS.keywords;
  const pageImage = image || DEFAULT_IMAGE;
  const pageUrl = url ? SITE_URL + url : SITE_URL;

  const jsonLdString = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'EducationalOrganization',
    name: SITE_NAME,
    url: SITE_URL,
    logo: DEFAULT_IMAGE,
    description: SEO_DEFAULTS.description,
    address: {
      '@type': 'PostalAddress',
      streetAddress: 'Cocody Angre 8e Tranche, Carrefour Priere, Rue L259',
      addressLocality: 'Abidjan',
      addressCountry: 'CI',
      postalCode: 'BP 1238'
    },
    telephone: ['+2250712651719', '+2250100959518'],
    email: 'cefat.bs@gmail.com',
    sameAs: [
      'https://facebook.com/cefatbs',
      'https://linkedin.com/company/cefat',
      'https://instagram.com/cefatbs'
    ],
    areaServed: {
      '@type': 'Country',
      name: 'Cote d\'Ivoire'
    }
  });

  return (
    <Helmet
      title={pageTitle}
      meta={[
        { name: 'description', content: pageDesc },
        { name: 'keywords', content: pageKeywords },
        { property: 'og:type', content: type },
        { property: 'og:title', content: pageTitle },
        { property: 'og:description', content: pageDesc },
        { property: 'og:image', content: pageImage },
        { property: 'og:url', content: pageUrl },
        { property: 'og:site_name', content: SITE_NAME },
        { property: 'og:locale', content: 'fr_CI' },
        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:title', content: pageTitle },
        { name: 'twitter:description', content: pageDesc },
        { name: 'twitter:image', content: pageImage },
        ...(noindex ? [{ name: 'robots', content: 'noindex,nofollow' }] : []),
      ]}
      link={[
        { rel: 'canonical', href: pageUrl },
      ]}
      script={[
        { type: 'application/ld+json', innerHTML: jsonLdString },
      ]}
    />
  );
}
